import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

import DashboardLayout from "../../../layouts/dashboardLayout";
import { titlePage } from "../../../helpers/titleHead";

import { getTargetMediaDetailAction } from "../../../../redux/action/serviceAction.js";

import DetailTargetMediaModule from "../../../modules/Admin/TargetMedia/DetailTargetMediaModule";

const DetailTargetMediaPage = () => {
  const dispatch = useDispatch();
  const queryParams = useParams();

  useEffect(() => {
    titlePage({
      title: "IRIS - Detail Target Media",
    });
    dispatch(getTargetMediaDetailAction(queryParams?.mediaId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <DashboardLayout title="Detail Target Media" menu="target-media">
      <DetailTargetMediaModule mediaId={queryParams?.mediaId} />
    </DashboardLayout>
  );
};

export default DetailTargetMediaPage;
